import { render, staticRenderFns } from "./ContentsMenu.vue?vue&type=template&id=4bb4b68a&scoped=true&"
import script from "./ContentsMenu.vue?vue&type=script&lang=js&"
export * from "./ContentsMenu.vue?vue&type=script&lang=js&"
import style0 from "./ContentsMenu.vue?vue&type=style&index=0&id=4bb4b68a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb4b68a",
  null
  
)

export default component.exports